<!--section-->
<section class="gray-bg small-padding no-top-padding-sec" id="sec1">
    <div class="container">
        <div class="breadcrumbs inline-breadcrumbs fl-wrap block-breadcrumbs">
            <a routerLinkActive="active" routerLink="">Home</a><a routerLinkActive="active" routerLink="/products">Product List</a><span> {{product.sellProductTitle}} </span>
            <div class="showshare brd-show-share color2-bg"> <i class="fas fa-share"></i> Share </div>
        </div>
        <div class="share-holder hid-share sing-page-share top_sing-page-share">
            <div class="share-container isShare"></div>
        </div>
        <div class="mob-nav-content-btn  color2-bg show-list-wrap-search ntm fl-wrap" [ngClass]="hideshow ? 'slsw_vis' : ''" (click)="toggle()"><i class="fal fa-filter"></i> Send Enquiry </div>
        <div class="fl-wrap">
            <div class="row">
                <div class="col-md-4">
                    <div class="fl-wrap lws_mobile" [ngClass]="hideshow ? 'd-block' : ''">
                        <div class="box-widget-item fl-wrap block_box">
                            <div class="box-widget-item-header">
                                <h3>Send Enquiry</h3>
                            </div>
                            <div class="box-widget">
                                <div class="box-widget-content">
                                  <app-send-enquiry></app-send-enquiry> 
                                </div>
                            </div>
                        </div>
                        <!--box-widget-item -->
                        <div class="box-widget-item fl-wrap block_box">
                            <div class="box-widget-item-header">
                                <h3>Location / Contacts </h3>
                            </div>
                            <div class="box-widget">
                                <app-location-details [userInfoId]="userInfoId"></app-location-details>
                            </div>
                        </div>
                        <!--box-widget-item end -->

                        <!--Category box-widget-item -->
                        <div class="box-widget-item fl-wrap block_box">
                            <div class="box-widget-item-header">
                                <h3>Business Categories</h3>
                            </div>
                            <div class="box-widget fl-wrap">
                                <div class="box-widget-content scrollbox">
                                    <ul class="cat-item no-list-style">
                                        <app-categories-list></app-categories-list>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!--Category box-widget-item end -->

                         <!--Advertiser box-widget-item -->
                        <div class="box-widget-item fl-wrap block_box">
                            <div class="box-widget-item-header">
                                <h3>Premium Advertiser</h3>
                            </div>
                            <div class="box-widget opening-hours fl-wrap">
                                <div class="box-widget-content">
                                    <app-premium-ads></app-premium-ads>
                                </div>
                            </div>
                        </div>
                        <!--Advertiser box-widget-item end -->
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="fl-wrap block_box product-header">
                        <div class="product-header-details">
                            <span class="phd_sale green-bg">Sale {{product.sellProductDiscount}}</span>
                            <div class="row">
                                <div class="col-md-6">
                                    <div style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff" class="swiper mySwiper">
                                        <div class="swiper-wrapper">
                                          <div class="swiper-slide">
                                            <div class="swiper-zoom-container">
                                                <img [src]="[serverImgUrl] + 'sellProducts/' + [product.sellProductImageURL] || '../../assets/images/shop/1.jpg'" alt="{{product.sellProductTitle}}">
                                            </div>
                                          </div>
                                          <div class="swiper-slide">
                                            <div class="swiper-zoom-container">
                                                <img src="../../assets/images/shop/1.jpg" alt="Product image unavailable" loading="lazy" decoding="async" />
                                            </div>
                                          </div>
                                        </div>
                                        <div class="swiper-button-next"></div>
                                        <div class="swiper-button-prev"></div>
                                        <div class="swiper-pagination hide"></div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <h3>{{product.sellProductTitle}}</h3>
                                    <span class="product-header-details_price old-price">{{product.sellProductPrice | currency:"₹"}}</span>
                                    <span class="product-header-details_price">{{ product.sellProductPrice - ((product.sellProductPrice * product.sellProductDiscount) / 100) | currency:"₹" }}</span>
                                    <div class="listing-rating-count-wrap">
                                        <div class="review-score">{{feedAvg | number:'1.1-1'}}</div>
                                        <div class="listing-rating">
                                            <app-star-rating [rating]='feedAvg' [readonly]="true"></app-star-rating>
                                        </div>
                                        <div class="reviews-count">({{feedTotal}} reviews)</div>
                                    </div>
                                    <span class="fw-separator"></span>
                                    <div class="clearfix"></div>
                                    <p>{{product.sellProductDetails}} </p>
                                    <span class="fw-separator"></span>
                                    <div class="custom-form product-header_form ">
                                        <div class="quantity">
                                            <div class="quantity-item">
                                                <input type="button" value="-" class="minus">
                                                <input type="text" name="quantity" title="Qty" ngModel="{{qty}}" class="qty color-bg" data-min="3" data-max="100" data-step="1">
                                                <input type="button" value="+" class="plus">
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <button class="btn btn-primary ms-0" disabled (click)="addToCart(product)">Add to Cart <i class="far fa-shopping-cart ms-2"></i> </button>
                                        <button class="btn btn-secondary ms-0 ms-sm-2 mt-2 mt-sm-0" disabled (click)="buyNow(product)">Buy Now <i class="far fa-shopping-basket ms-2"></i> </button>
                                    </div>
                                </div>
                            </div>
                            <span class="fw-separator hide"></span>
                            <div class="list-single-tags tags-stylwrap hide">
                                <span class="tags-title"><i class="fas fa-tag"></i> Tags : </span>
                                <a href="#">Market</a>
                                <a href="#">Hot</a>
                                <a href="#">Drinks</a>
                                <a href="#">Coffee</a>
                                <a href="#">Restourant</a>
                            </div>
                        </div>
                    </div>
                    <!-- shop-tabs-->
                    <div class="mb-4 fl-wrap">
                        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav nav-tabs w-100 mt-2">
                            <li [ngbNavItem]="1">
                                <button ngbNavLink class="nav-link btn">Product Description</button>
                                <ng-template ngbNavContent>
                                    <!--tab -->
                                    <div class="fl-wrap block_box">
                                        <div class="p-4">
                                            <p>{{product.sellProductAdditionalInfo}}</p>
                                        </div>
                                    </div>
                                    <!--tab end-->
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="2">
                                <button ngbNavLink class="nav-link btn">Additional information</button>
                                <ng-template ngbNavContent>
                                    <!--tab -->
                                    <div class="fl-wrap block_box">
                                        <div class="p-4">
                                            <ul class="no-list-style shop-list fl-wrap">
                                                <li><span>Product Name :</span>{{product.sellProductTitle}}</li>
                                                <li><span>Product Number :</span># {{product.sellProductInfoId}}</li>
                                                <li><span>Product Price : </span> {{product.sellProductPrice}}</li>
                                                <li><span>Product Discount : </span> {{product.sellProductDiscount}}</li>
                                                <li><span>Product weight : </span> {{product.sellProductAdditionalInfo}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <!--tab end-->
                                </ng-template>
                            </li>
                        </ul>
                        <div [ngbNavOutlet]="nav" class="d-block" style="margin-top: -7px;"></div>
                    </div>
                    <!-- shop-tabs end-->

                    <!-- Ads item -->
                    <div class="list-single-main-item fl-wrap block_box">
                        <div class="list-single-main-item-title">
                            <h3>Related Items and Ads</h3>
                        </div>
                        <div class="list-single-main-item_content  fl-wrap">
                            <!-- shop-item  -->
                            <app-similer-product></app-similer-product>
                            <!-- shop-item end --> 
                        </div>
                    </div>
                    <!-- Ads item end -->
                    
                    <!-- Review item -->
                    <app-review></app-review>
                    <!-- Review end -->
                </div>
            </div>
        </div>
    </div>
</section>
<!--section end-->
<div class="limit-box fl-wrap"></div>

<!-- <app-cart></app-cart> -->